function ZoomInIcon(props)
{
    return(
        <svg className={props.class} viewBox="0 0 24 24" fill="none">
<path d="M19.9604 11.4802C19.9604 13.8094 19.0227 15.9176 17.5019 17.4512C16.9332 18.0247 16.2834 18.5173 15.5716 18.9102C14.3594 19.5793 12.9658 19.9604 11.4802 19.9604C6.79672 19.9604 3 16.1637 3 11.4802C3 6.79672 6.79672 3 11.4802 3C16.1637 3 19.9604 6.79672 19.9604 11.4802Z" stroke="#ffffffff" strokeWidth="2"/>
<path d="M18.1553 18.1553L21.8871 21.8871" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round"/>
<path d="M8 11.5492H15.0983" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round"/>
<path d="M8 11.5492H15.0983" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round"/>
<path d="M11.5492 15.0984L11.5492 8.00006" stroke="#ffffffff" strokeWidth="2" strokeLinecap="round"/>
</svg>
    )
}

export default ZoomInIcon